import { httpsCallable } from "firebase/functions";
import { db, functions } from "../config/firebase-config";
import { toast } from "react-toastify";
import moment from "moment";
import { getBotStatus } from "../functions";
import { getCurrentUser } from "../services/UserService"
import { partialUpdateUserBotMeetings } from "../services/UserBotMeetingService"

export const setBotStatus = async (meeting) => {
  console.log("meeting - ", meeting);
  if (meeting?.botStatus?.history.find((x) => x.code === "done")) {
    showBotStatus(meeting?.botStatus?.history);
  } else {

    getBotStatus({ bot_id: meeting?.botId }, (response) => {
      let botStatusData = response.data;
      if (botStatusData === null) {
        toast.error("Couldn't fetch status, try later!");
      }

      let status = {
        ...botStatusData,
        history: botStatusData?.history.map((item) => {
          return {
            code: item.code,
            createdAt: moment(item.created_at).toDate(),
            message: item.message,
            sub_code: item.sub_code,
          };
        }),
      };
      showBotStatus(status.history);
  
      let user = getCurrentUser();
      partialUpdateUserBotMeetings(user.uid, meeting.id, { botStatus: status })
    }, (error) => {

    })
  }
};
const showBotStatus = (history) => {
  const code = history[history.length - 1].code;
  if (code === "ready") toast.success("The bot is ready to join the meeting");
  if (code === "joining_call") toast.info("The bot is joining the call");
  if (code === "in_waiting_room") toast.info("The bot is in the waiting room");
  if (code === "in_call_not_recording")
    toast.info("The bot has joined the meeting, however is not recording yet");
  if (code === "in_call_recording")
    toast.info(
      "The bot is in the meeting, and is currently recording the audio and video"
    );
  if (code === "call_ended") toast.info(history[history.length - 1].message);
  if (code === "done") toast.info("The bot has shut down/meeting over");
  if (code === "fatal")
    toast.info(
      "The bot has encountered an error that prevented it from joining the call"
    );
};
